import { render, staticRenderFns } from "./stringProfit.vue?vue&type=template&id=0f74da24&scoped=true&"
import script from "./stringProfit.vue?vue&type=script&lang=js&"
export * from "./stringProfit.vue?vue&type=script&lang=js&"
import style0 from "./stringProfit.vue?vue&type=style&index=0&id=0f74da24&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f74da24",
  null
  
)

export default component.exports